export const GET_USER_INFO_BY_CODE = "user/GET_USER_INFO_BY_CODE";
export const GET_USER_INFO_BY_CODE_SUCCESS =
  "user/GET_USER_INFO_BY_CODE_SUCCESS";
export const GET_USER_INFO_BY_CODE_FAIL = "user/GET_USER_INFO_BY_CODE_FAIL";

export const USER_LOG_OUT = "user/LOG_OUT";
export const USER_LOG_OUT_WITHOUT_NOTI = "user/LOG_OUT_WITHOUT_NOTI";
export const USER_SESSSION_EXPIRED = "user/SESSSION_EXPIRED";

export const LOGIN_BY_FIREBASE = "user/LOGIN_BY_FIREBASE";

export const LOGIN_BY_ZALO = "user/LOGIN_BY_ZALO";

export const GET_CODE_LOGIN_SMS = "user/GET_CODE_LOGIN_SMS";
export const GET_CODE_LOGIN_SMS_SUCCESS = "user/GET_CODE_LOGIN_SMS_SUCCESS";

export const CHECK_CODE_LOGIN_SMS = "user/CHECK_CODE_LOGIN_SMS";
export const RESET_DATA_LOGIN_SMS = "user/RESET_DATA_LOGIN_SMS";

export const GET_CODE_REGISTER_SMS = "user/GET_CODE_REGISTER_SMS";
export const GET_CODE_REGISTER_SMS_SUCCESS =
  "user/GET_CODE_REGISTER_SMS_SUCCESS";
export const GET_CODE_REGISTER_SMS_ERROR = "user/GET_CODE_REGISTER_SMS_ERROR";

export const CHECK_CODE_REGISTER_SMS = "user/CHECK_CODE_REGISTER_SMS";
export const CHECK_CODE_REGISTER_SMS_SUCCESS =
  "user/CHECK_CODE_REGISTER_SMS_SUCCESS";
export const CHECK_CODE_REGISTER_SMS_ERROR =
  "user/CHECK_CODE_REGISTER_SMS_ERROR";

export const APPLY_PASS_REGISTER_SMS = "user/APPLY_PASS_REGISTER_SMS";
export const APPLY_PASS_REGISTER_SMS_SUCCESS =
  "user/APPLY_PASS_REGISTER_SMS_SUCCESS";
export const APPLY_PASS_REGISTER_SMS_ERROR =
  "user/APPLY_PASS_REGISTER_SMS_ERROR";

export const LOGIN_WITH_PASSWORD = "user/LOGIN_WITH_PASSWORD";
export const LOGIN_WITH_PASSWORD_SUCCESS = "user/LOGIN_WITH_PASSWORD_SUCCESS";
export const LOGIN_WITH_PASSWORD_ERROR = "user/LOGIN_WITH_PASSWORD_ERROR";

export const REGISTER_SOCIAL = "user/REGISTER_SOCIAL";
export const REGISTER_SOCIAL_SUCCESS = "user/REGISTER_SOCIAL_SUCCESS";
export const REGISTER_SOCIAL_ERROR = "user/REGISTER_SOCIAL_ERROR";

export const SET_TYPE_SOCIAL = "user/SET_TYPE_SOCIAL";
export const LOGIN_SOCIAL_SIGNIN = "user/LOGIN_SOCIAL_SIGNIN";
export const LOGIN_SOCIAL_SIGNIN_SUCCESS = "user/LOGIN_SOCIAL_SIGNIN_SUCCESS";
export const LOGIN_SOCIAL_SIGNIN_ERROR = "user/LOGIN_SOCIAL_SIGNIN_ERROR";
export const STORE_SOCIAL_INFO = "user/STORE_SOCIAL_INFO";

export const FORGOT_PASSWORD = "user/FORGOT_PASSWORD";
export const CHECK_CODE_FORGOT_PASSWORD = "user/CHECK_CODE_FORGOT_PASSWORD";

export const APPLY_PASS_FORGOT_PASSWORD = "user/APPLY_PASS_FORGOT_PASSWORD";

export const REQUIRE_REGISTER_SOCIAL = "user/REQUIRE_REGISTER_SOCIAL";
export const CLEAR_OTP_INFO = "user/CLEAR_OTP_INFO";
export const CLEAR_INTERVAL = "user/CLEAR_INTERVAL";
export const CLEAR_ERROR = "user/CLEAR_ERROR";

// tách repo
export const LOGIN_FROM_MEDPRO_ID = "user/LOGIN_FROM_MEDPRO_ID";
export const LOGIN_FAILED = "user/LOGIN_FAILED";
